import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

/** User-area routes — require user session (admin session can coexist). */
const PrivateRoute = ({ element: Component, ...rest }) => {
  const { userAuthenticated } = useAuth();

  if (!userAuthenticated) return <Navigate to="/login" replace />;
  return <Component {...rest} />;
};

export default PrivateRoute;
